module.exports = __webpack_public_path__ + "static/media/tech10_1.6ef306a5.jpg";